// https://github.com/FortAwesome/vue-fontawesome#integrating-with-other-tools-and-frameworks
import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faInfoCircle,
  faInfo,
  faCheck,
  faCaretDown,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faAngleDown,
  faLongArrowAltDown,
  faDownload,
  faSearch,
  faArrowsAltV,
  faGlobe,
  faExclamationCircle,
  faThumbtack,
  faHome,
  faMinus,
  faPlus,
  faExpand,
  faSquare,
  faTimes,
  faQuestion,
  faMousePointer,
} from "@fortawesome/free-solid-svg-icons";
import { faHandPointer } from "@fortawesome/free-regular-svg-icons";
// import { faFacebookF, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  // faFacebookF,
  // faTwitter,
  faInfoCircle,
  faInfo,
  faCaretDown,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faLongArrowAltDown,
  faDownload,
  faCheck,
  faSearch,
  faAngleDown,
  faArrowsAltV,
  faGlobe,
  faExclamationCircle,
  faThumbtack,
  faHome,
  faHandPointer,
  faMinus,
  faPlus,
  faExpand,
  faSquare,
  faQuestion,
  faTimes,
  faMousePointer
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
